import { useQuery } from '@tanstack/react-query';

import { APIResponse, defaultMetaQueryFn } from 'api/useAPI';
import { VehicleSummary } from 'models';

import { getInventoryQueryString } from '.';

/**
 * @package api/vendor-inventory
 * @description - Get summaries for vehicles with vendor tasks
 */
export function useGetVendorInventoryQuery(enabled = false) {
  const queryKey = getVendorInventoryQueryKey();
  return useQuery<APIResponse<VehicleSummary[]>>(
    queryKey,
    () => defaultMetaQueryFn(`${queryKey[0]}?${queryKey[1]}`),
    {
      enabled,
    }
  );
}

/**
 * @package api/vendor-inventory by vin
 * @description - Get summary for vehicle with vendor tasks
 */
export function useGetVendorInventoryIdsByVinQuery(
  enabled: boolean,
  vin: string | null
) {
  const url = getVendorInventoryQueryKey()?.[0];
  return useQuery<APIResponse<string[]>>(
    ['/vendor-inventory', vin],
    () => defaultMetaQueryFn(`${url}/vin/${vin}/inventoryIds`),
    {
      enabled,
    }
  );
}

export const getVendorInventoryQueryKey = () => {
  const path = '/vendor-inventory';
  const queryString = getInventoryQueryString();
  return [path, queryString];
};

export default useGetVendorInventoryQuery;
